//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useState, useEffect } from 'react';
// import './style.scss';
import { format } from 'date-fns';
import { ReactComponent as BackIcon } from '../../../assets/images/arrowLeft.svg';
import { t } from '@web-solutions/module-localization';
import Button from 'src/onboarding/components/ui/button/Button';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { useStore } from 'src/onboarding/store/store';
import { useNav } from 'src/onboarding/hooks/nav';
import GoalGraph from 'src/onboarding/components/ui/goalGraph/Graph';
import { getEarlyAchievableOffset } from 'src/onboarding/helpers/getEarlyAchievableOffset';

function Page() {
  const idealWeight = useStore((state) => state.idealWeight);
  const when = useStore((state) => state.when);
  const weight = useStore((state) => state.weight);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2' style={{ paddingLeft: 10 }}>
          {t('onboarding.goalSecond.title')}
        </Title>
        <Text size='m' medium className={'description'} style={{ padding: 0 }}>
          {getEarlyAchievableOffset(when) === 1
            ? `${t('onboarding.goalSecond.descriptionMonth1')} 🎉`
            : `${t('onboarding.goalSecond.description', { when: getEarlyAchievableOffset(when) })} 🎉`}
        </Text>
      </div>

      <GoalGraph
        weightNow={weight.type === 'kg' ? weight.kg : weight.lbs}
        targetDate={when}
        differenceDate={getEarlyAchievableOffset(when)}
        targetWeight={idealWeight.value}
        unit={weight.type === 'kg' ? 'kg' : 'lbs'}
      />

      <div className={'next-wrapper'}>
        <Button title={t('onboarding.goalSecond.continue')} onClick={onNext} />
      </div>
    </div>
  );
}

export default Page;
